module.exports = __webpack_public_path__ + "static/media/Annika.7682c13d.md";